import { render, staticRenderFns } from "./banner-icon-select.vue?vue&type=template&id=19862880"
import script from "./banner-icon-select.vue?vue&type=script&lang=js"
export * from "./banner-icon-select.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports